import { Box, Grid, StepConnector, InputAdornment, MenuItem, Select, Stack, Step, StepLabel, Stepper, TextField, Tooltip, Typography } from '@mui/material'
import { InfoOutlined } from "@mui/icons-material";
import { useRef, useState } from 'react'
import Header from '../../core/Header/Header'
import './style.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { hideLoader, showLoader, setUserDetail } from '../../Store/mainSlice'
import httpClient from '../../_util/api'
import CustomizedSnackbars from '../../shared/Snackbar/SnackBar'
import { UploadImagetoFb } from '../../Hooks/uploadImage'
import ButtonMain from '../../components/Button';
import FileUpload from '../../components/FileUpload';
import { getRedirectPath } from '../../Helpers/Redirect';
import { setAuthSessionExpiry } from '../../_util/session';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const OnBoardingForm = () => {
  const userdetail = useSelector((state) => state.mainSlice.userdetail);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const snackbar_Ref = useRef()
  const transcriptPhotoRef = useRef()
  const voucherPhotoRef = useRef()
  const studentCNICPhotoRef = useRef()
  const studentCNICBackPhotoRef = useRef()
  const parentCNICPhotoRef = useRef()
  const parentCNICBackPhotoRef = useRef()
  const proofOfIncomePicRef = useRef()
  const currentBillPicRef = useRef()
  const additionalDocsRef = useRef()
  const otherDocumentsRef = useRef()
  const referenceletterRef1 = useRef()
  const referenceletterRef2 = useRef()
  const [activeStep, setActiveStep] = useState(0);

  const [studentData, setStudentData] = useState({
    firstName: "",
    lastName: "",
    email: userdetail.email,
    gender: "",
    address: "",
    town: "",
    phoneNo_Mobile: "",
    phoneNo_Home: "",
    CNICNo: userdetail.CNICNo,
    country: "",
    presentHouseholdIncome: 0,
    totalFamilyMembers: 0,
    fatherName: "",
    motherName: "",
    orphan: "",
    referenceName1: "",
    referenceEmail1: "",
    referencePhone1: "",
    referenceName2: "",
    referenceEmail2: "",
    referencePhone2: "",
    additionalDocs: {
      fileName: "",
      url: ""
    },
    otherDocumentsFile: {
      fileName: "",
      url: ""
    },
    resultOfLastExamFile: {
      fileName: "",
      url: ""
    },
    feeVoucherFile: {
      fileName: "",
      url: ""
    },
    CNICFrontFile: {
      fileName: "",
      url: ""
    },
    CNICBackFile: {
      fileName: "",
      url: ""
    },
    parentCNICFrontFile: {
      fileName: "",
      url: ""
    },
    parentCNICBackFile: {
      fileName: "",
      url: ""
    },
    proofOfIncomeFile: {
      fileName: "",
      url: ""
    },
    currentElectricBillFile: {
      fileName: "",
      url: ""
    },
    referenceLetterFile1: {
      fileName: "",
      url: ""
    },
    referenceLetterFile2: {
      fileName: "",
      url: ""
    },
    countryCode: "+92"
  })

  const countryCodes = [
    { label: '+1', value: 'US' },
    { label: '+44', value: 'UK' },
    { label: '+92', value: 'Pakistan' },
    { label: '+91', value: 'India' },
  ];

  const nextHandler = () => {
    setActiveStep((currentStep) => currentStep + 1);
  }

  const previousHandler = () => {
    setActiveStep((currentStep) => currentStep - 1);
  }

  const handleInputChange = (data, field, fieldType) => {
    const updatedValue = fieldType === 'number' ? parseFloat(data) : data;
    setStudentData((prevFormData) => ({ ...prevFormData, [field]: updatedValue }));
  };

  const uploadPhotoHandler = (refType) => {
    const refCreator = {
      transcriptPhotoRef,
      voucherPhotoRef,
      studentCNICPhotoRef,
      studentCNICBackPhotoRef,
      parentCNICPhotoRef,
      parentCNICBackPhotoRef,
      proofOfIncomePicRef,
      currentBillPicRef,
      additionalDocsRef,
      otherDocumentsRef,
      referenceletterRef1,
      referenceletterRef2,
    }[refType];

    if (refCreator) {
      refCreator?.current?.click();
    }
  };

  const handleFileChange = async (event, field) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileType = file.type;

    if (fileType !== "application/pdf") {
      alert('Please upload a PDF file.');
      return;
    }

    const MAX_FILE_SIZE_MB = 1.5;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

    if (file.size > MAX_FILE_SIZE_BYTES) {
      alert(`File size should not exceed ${MAX_FILE_SIZE_MB} MB.`);
      return;
    }

    dispatch(showLoader());

    try {
      const newFile = {};
      const uploadedFile = await UploadImagetoFb(event);

      newFile.fileName = file.name;
      newFile.url = uploadedFile.url;

      if (field === "multiple") {
        if (Array.isArray(studentData.additionalDocs)) {
          setStudentData((prev) => ({
            ...prev,
            [field]: [...prev[field], newFile],
          }));
        }
      } else {
        setStudentData((prev) => ({
          ...prev,
          [field]: newFile,
        }));
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("File upload failed. Please try again.");
    } finally {
      dispatch(hideLoader());
    }
  };

  const addStudentDetailsHandler = async () => {
    // Validation for required fields
    const requiredFields = [
      { field: studentData.firstName, name: "First Name" },
      { field: studentData.lastName, name: "Last Name" },
      { field: studentData.email, name: "Email" },
      { field: studentData.gender, name: "Gender" },
      { field: studentData.country, name: "Country" },
      { field: studentData.town, name: "City" },
      { field: studentData.address, name: "Address" },
      { field: studentData.CNICNo, name: "CNIC No" },
      { field: studentData.phoneNo_Mobile, name: "Phone Number (Mobile)" },
      { field: studentData.phoneNo_Home, name: "Phone Number (Home)" },
      { field: studentData.fatherName, name: "Father Name" },
      { field: studentData.motherName, name: "Mother Name" },
      { field: studentData.orphan, name: "Orphan (Yes/No)" },
      { field: studentData.presentHouseholdIncome, name: "Gross Household Income" },
      { field: studentData.totalFamilyMembers, name: "Total Family Members" }
    ];

    const missingFields = requiredFields.filter(item => !item.field || item.field === 0 || item.field === "");

    if (missingFields.length > 0) {
      const missingFieldNames = missingFields.map(item => item.name).join(", ");
      snackbar_Ref.current.showMessage(
        "error", 
        `Please fill the following required fields: ${missingFieldNames}`, 
        "", 
        "i-chk-circle"
      );
      return;
    }

    // Validate CNIC format (should be 13 digits in format: 00000-0000000-0)
    if (studentData.CNICNo.replace(/-/g, "").length !== 13) {
      snackbar_Ref.current.showMessage("error", "Please enter a valid 13-digit CNIC number", "", "i-chk-circle");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(studentData.email)) {
      snackbar_Ref.current.showMessage("error", "Please enter a valid email address", "", "i-chk-circle");
      return;
    }

    nextHandler();
  };

  const addReferenceDetailsHandler = async () => {
    // Validation for reference fields
    if (!studentData.referenceName1 || !studentData.referenceEmail1 || !studentData.referencePhone1 ||
        !studentData.referenceName2 || !studentData.referenceEmail2 || !studentData.referencePhone2) {
      snackbar_Ref.current.showMessage("error", "Please fill all reference fields", "", "i-chk-circle");
      return;
    }

    // Validation for reference letter files
    if (!studentData.referenceLetterFile1.url || !studentData.referenceLetterFile2.url) {
      snackbar_Ref.current.showMessage("error", "Please upload both reference letters", "", "i-chk-circle");
      return;
    }

    nextHandler();
  };

  const addAttachmentDetailHandler = async () => {
    // Validation for required attachment files
    const requiredFiles = [
      { file: studentData.CNICFrontFile, name: "Student CNIC/B-Form (Front)" },
      { file: studentData.CNICBackFile, name: "Student CNIC/B-Form (Back)" },
      { file: studentData.parentCNICFrontFile, name: "Parents CNIC (Front)" },
      { file: studentData.parentCNICBackFile, name: "Parents CNIC (Back)" },
      { file: studentData.proofOfIncomeFile, name: "Proof of Income" },
      { file: studentData.currentElectricBillFile, name: "Current Electric Bill" },
      { file: studentData.additionalDocs, name: "Matric and Intermediate Marksheet" }
    ];

    const missingFiles = requiredFiles.filter(item => !item.file.url);

    if (missingFiles.length > 0) {
      const missingFileNames = missingFiles.map(item => item.name).join(", ");
      snackbar_Ref.current.showMessage(
        "error", 
        `Please upload the following required documents: ${missingFileNames}`, 
        "", 
        "i-chk-circle"
      );
      return;
    }

    dispatch(showLoader());
    try {
      const res = await httpClient.post('/students/complete-onboarding', studentData);
      debugger;
      if (res?.status === 200) {
        const { token, role } = res.data;
        localStorage.setItem('authToken', token);
        setAuthSessionExpiry();
        dispatch(setUserDetail(res.data));
        navigate(getRedirectPath(role));
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      snackbar_Ref.current.showMessage("error", error?.response?.data?.message || "An error occurred", "", "i-chk-circle");
    }
  };

  const handleCNICNoChange = (data) => {
    let value = data.replace(/[^0-9]/g, "");
    let formattedValue = "";

    if (value.length > 5) {
      formattedValue += value.substring(0, 5) + "-";
      if (value.length > 12) {
        formattedValue += value.substring(5, 12) + "-";
        formattedValue += value.substring(12, 13);
      }
      else if (value.length > 5) {
        formattedValue += value.substring(5);
      }
    } else {
      formattedValue = value;
    }

    setStudentData((prev) => ({ ...prev, CNICNo: formattedValue }))
  }

  console.log("studentdata", studentData)
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ width: 'auto', height: '100vh', backgroundColor: '#f5f5f5' }}>
      <Header />
      <Box
        sx={{ width: isMobile ? 'auto' : '50%', margin: "auto", mt: 12, backgroundColor: "white", padding: 4, height: "80vh", overflow: "hidden", overflowY: "scroll" }}
      >
        <CustomizedSnackbars ref={snackbar_Ref} />
        <Stepper
          activeStep={activeStep}
          connector={<StepConnector />}
          sx={{
            "& .MuiStepLabel-label": { fontSize: "1.2rem" },
            "& .MuiStepIcon-root": { fontSize: "2.5rem" },
            "& .Mui-active .MuiStepIcon-root": { color: "#4caf50" },
            "& .Mui-completed .MuiStepIcon-root": { color: "#4caf50" },
          }}
        >
          {['Student Details', 'References', 'Attachments'].map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        
        <Grid item xs={10}>
          {activeStep === 0 ? (
            <Stack alignItems={'center'} justifyContent={'center'}>
              <h2>STUDENT DETAILS</h2>
              <Box
                sx={{
                  width: '100%',
                  boxSizing: 'border-box',
                  backgroundColor: '#fff3f3',
                  border: '1px solid #ffcccc',
                  padding: '16px',
                  borderRadius: 2,
                  mb: 2,
                }}
              >
                <Typography color="error" fontWeight={600}>
                  All fields are required*
                </Typography>
              </Box>
              
              <Stack className="grid-2" justifyContent={'space-between'}>
                <TextField
                  required
                  label="First Name"
                  value={studentData.firstName}
                  onChange={(e) => handleInputChange(e.target.value, "firstName", "text")}
                />
                <TextField
                  required
                  label="Last Name"
                  value={studentData.lastName}
                  onChange={(e) => handleInputChange(e.target.value, "lastName", "text")}
                />
                <TextField
                  required
                  label="Preferred Email"
                  value={studentData.email}
                  onChange={(e) => handleInputChange(e.target.value, "email", "text")}
                />
                <Select
                  value={studentData.gender}
                  onChange={(e) => handleInputChange(e.target.value, "gender", "text")}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select Gender</MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
                <TextField
                  required
                  label="Country"
                  value={studentData.country}
                  onChange={(e) => handleInputChange(e.target.value, "country", "text")}
                />
                <TextField
                  required
                  label="City"
                  value={studentData.town}
                  onChange={(e) => handleInputChange(e.target.value, "town", "text")}
                />
                <TextField
                  required
                  label="Address"
                  value={studentData.address}
                  onChange={(e) => handleInputChange(e.target.value, "address", "text")}
                />
                <TextField
                  required
                  label="CNIC NO"
                  placeholder='00000-0000000-0'
                  value={studentData.CNICNo}
                  onChange={(e) => handleCNICNoChange(e.target.value)}
                />
                <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                  <Select
                    value={studentData.countryCode}
                    onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                    displayEmpty
                    sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                  >
                    {countryCodes.map((country) => (
                      <MenuItem key={country.label} value={country.label}>
                        ({country.label})
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    required
                    label="Phone Number (Mobile)"
                    type="number"
                    value={studentData.phoneNo_Mobile}
                    onChange={(e) => handleInputChange(e.target.value, "phoneNo_Mobile", "text")}
                    sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  />
                </Box>
                <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                  <Select
                    value={studentData.countryCode}
                    onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                    displayEmpty
                    sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                  >
                    {countryCodes.map((country) => (
                      <MenuItem key={country.label} value={country.label}>
                        ({country.label})
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    required
                    label="Phone Number (Home)"
                    type="number"
                    value={studentData.phoneNo_Home}
                    onChange={(e) => handleInputChange(e.target.value, "phoneNo_Home", "text")}
                    sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  />
                </Box>
                <TextField
                  required
                  label="Father Name"
                  value={studentData.fatherName}
                  onChange={(e) => handleInputChange(e.target.value, "fatherName", "text")}
                />
                <TextField
                  required
                  label="Mother Name"
                  value={studentData.motherName}
                  onChange={(e) => handleInputChange(e.target.value, "motherName", "text")}
                />
                <Select
                  value={studentData.orphan}
                  onChange={(e) => handleInputChange(e.target.value, "orphan", "text")}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Orphan? (Yes/No)</MenuItem>
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
                <TextField
                  required
                  label="Gross Household Income"
                  type='Number'
                  value={studentData.presentHouseholdIncome}
                  onChange={(e) => handleInputChange(e.target.value, "presentHouseholdIncome", "number")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Please enter the total income of all earning members of the household, including the parent(s).">
                          <InfoOutlined sx={{ fontSize: 18, color: 'rgba(0, 0, 0, 0.54)', cursor: 'help' }} />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  required
                  label="Total Family Members"
                  type='Number'
                  value={studentData.totalFamilyMembers}
                  onChange={(e) => handleInputChange(e.target.value, "totalFamilyMembers", "number")}
                />
              </Stack>
              
              <Stack sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                mt: 2,
                gap: 2,
                width: "100%",
              }}>
                <ButtonMain
                  variant="green"
                  onClick={addStudentDetailsHandler}
                >
                  Save and Continue
                </ButtonMain>
              </Stack>
            </Stack>
          ) : activeStep === 1 ? (
            <Stack alignItems={'center'} justifyContent={'center'}>
              <h2>APPLY FOR MERITORIOUS SCHOLARSHIP - REFERENCES</h2>
              <Box
                sx={{
                  width: '100%',
                  boxSizing: 'border-box',
                  backgroundColor: '#fff3f3',
                  border: '1px solid #ffcccc',
                  padding: '16px',
                  borderRadius: 2,
                  mb: 2,
                }}
              >
                <Typography color="error" fontWeight={600}>
                  Please follow the instructions carefully:
                </Typography>
                <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                  <li>
                    <Typography color="error">All fields are required*</Typography>
                  </li>
                  <li>
                    <Typography color="error">
                      Two reference letters. The person referring should include his/her email and cell number
                    </Typography>
                  </li>
                  <li>
                    <Typography color="error">
                      All documents must be scanned in <strong>PDF format</strong>. Pictures are not accepted.
                    </Typography>
                  </li>
                  <li>
                    <Typography color="error">
                      Each file must not exceed <strong>1.5 MB</strong> in size.
                    </Typography>
                  </li>
                </ul>
              </Box>
              
              <Stack className="grid-2" justifyContent={'space-between'}>
                <TextField
                  required
                  label="Reference 1 Name"
                  value={studentData.referenceName1}
                  onChange={(e) => handleInputChange(e.target.value, "referenceName1", "text")}
                />
                <TextField
                  required
                  label="Reference 1 Email"
                  value={studentData.referenceEmail1}
                  onChange={(e) => handleInputChange(e.target.value, "referenceEmail1", "text")}
                />
                <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                  <Select
                    value={studentData.countryCode}
                    onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                    displayEmpty
                    sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                  >
                    {countryCodes.map((country) => (
                      <MenuItem key={country.label} value={country.label}>
                        ({country.label})
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    required
                    label="Reference 1 Phone"
                    type="number"
                    value={studentData.referencePhone1}
                    onChange={(e) => handleInputChange(e.target.value, "referencePhone1", "text")}
                    sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  />
                </Box>
                <FileUpload
                  ref={referenceletterRef1}
                  file={studentData.referenceLetterFile1}
                  label="Reference Letter 1"
                  onChange={(e) => handleFileChange(e, "referenceLetterFile1")}
                  onClick={() => uploadPhotoHandler("referenceletterRef1")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      referenceLetterFile1: { fileName: "", url: "" },
                    }))
                  }
                />
                <TextField
                  required
                  label="Reference 2 Name"
                  value={studentData.referenceName2}
                  onChange={(e) => handleInputChange(e.target.value, "referenceName2", "text")}
                />
                <TextField
                  required
                  label="Reference 2 Email"
                  value={studentData.referenceEmail2}
                  onChange={(e) => handleInputChange(e.target.value, "referenceEmail2", "text")}
                />
                <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                  <Select
                    value={studentData.countryCode}
                    onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                    displayEmpty
                    sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                  >
                    {countryCodes.map((country) => (
                      <MenuItem key={country.label} value={country.label}>
                        ({country.label})
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    required
                    label="Reference 2 Phone"
                    type="number"
                    value={studentData.referencePhone2}
                    onChange={(e) => handleInputChange(e.target.value, "referencePhone2", "text")}
                    sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  />
                </Box>
                <FileUpload
                  ref={referenceletterRef2}
                  file={studentData.referenceLetterFile2}
                  label="Reference Letter 2"
                  onChange={(e) => handleFileChange(e, "referenceLetterFile2")}
                  onClick={() => uploadPhotoHandler("referenceletterRef2")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      referenceLetterFile2: { fileName: "", url: "" },
                    }))
                  }
                />
              </Stack>
              
              <Stack sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                mt: 2,
                gap: 2,
                width: "100%",
              }}>
                <ButtonMain
                  variant="white"
                  onClick={previousHandler}
                >
                  Back
                </ButtonMain>
                <ButtonMain
                  variant="green"
                  onClick={addReferenceDetailsHandler}
                >
                  Continue
                </ButtonMain>
              </Stack>
            </Stack>
          ) : activeStep === 2 ? (
            <Stack alignItems={'center'} justifyContent={'center'} sx={{ height: '100%' }}>
              <h2>ATTACHMENTS</h2>
              <Box
                sx={{
                  width: '100%',
                  boxSizing: 'border-box',
                  backgroundColor: '#fff3f3',
                  border: '1px solid #ffcccc',
                  padding: '16px',
                  borderRadius: 2,
                  mb: 2,
                }}
              >
                <Typography color="error" fontWeight={600}>
                  Please follow the instructions carefully:
                </Typography>
                <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                  <li>
                    <Typography color="error">All fields are required*</Typography>
                  </li>
                  <li>
                    <Typography color="error">
                      All documents must be scanned in <strong>PDF format</strong>. Pictures are not accepted.
                    </Typography>
                  </li>
                  <li>
                    <Typography color="error">
                      Each file must not exceed <strong>1.5 MB</strong> in size.
                    </Typography>
                  </li>
                </ul>
              </Box>
              
              <Stack className="grid-2" justifyContent={'space-between'}>
                <FileUpload
                  ref={studentCNICPhotoRef}
                  file={studentData.CNICFrontFile}
                  label="Student CNIC / B-Form (Front)"
                  onChange={(e) => handleFileChange(e, "CNICFrontFile")}
                  onClick={() => uploadPhotoHandler("studentCNICPhotoRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      CNICFrontFile: { fileName: "", url: "" },
                    }))
                  }
                />
                <FileUpload
                  ref={studentCNICBackPhotoRef}
                  file={studentData.CNICBackFile}
                  label="Student CNIC / B-Form (Back)"
                  onChange={(e) => handleFileChange(e, "CNICBackFile")}
                  onClick={() => uploadPhotoHandler("studentCNICBackPhotoRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      CNICBackFile: { fileName: "", url: "" },
                    }))
                  }
                />
                <FileUpload
                  ref={parentCNICPhotoRef}
                  file={studentData.parentCNICFrontFile}
                  label="Parents CNIC (Front)"
                  onChange={(e) => handleFileChange(e, "parentCNICFrontFile")}
                  onClick={() => uploadPhotoHandler("parentCNICPhotoRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      parentCNICFrontFile: { fileName: "", url: "" },
                    }))
                  }
                />
                <FileUpload
                  ref={parentCNICBackPhotoRef}
                  file={studentData.parentCNICBackFile}
                  label="Parents CNIC (Back)"
                  onChange={(e) => handleFileChange(e, "parentCNICBackFile")}
                  onClick={() => uploadPhotoHandler("parentCNICBackPhotoRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      parentCNICBackFile: { fileName: "", url: "" },
                    }))
                  }
                />
                <FileUpload
                  ref={proofOfIncomePicRef}
                  file={studentData.proofOfIncomeFile}
                  label="Proof of Income"
                  onChange={(e) => handleFileChange(e, "proofOfIncomeFile")}
                  onClick={() => uploadPhotoHandler("proofOfIncomePicRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      proofOfIncomeFile: { fileName: "", url: "" },
                    }))
                  }
                />
                <FileUpload
                  ref={currentBillPicRef}
                  file={studentData.currentElectricBillFile}
                  label="Current Electric Bill"
                  onChange={(e) => handleFileChange(e, "currentElectricBillFile")}
                  onClick={() => uploadPhotoHandler("currentBillPicRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      currentElectricBillFile: { fileName: "", url: "" },
                    }))
                  }
                />
                <FileUpload
                  ref={additionalDocsRef}
                  file={studentData.additionalDocs}
                  label="Matric and Intermediate Marksheet"
                  onChange={(e) => handleFileChange(e, "additionalDocs")}
                  onClick={() => uploadPhotoHandler("additionalDocsRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      additionalDocs: { fileName: "", url: "" },
                    }))
                  }
                />
                <FileUpload
                  ref={otherDocumentsRef}
                  file={studentData.otherDocumentsFile}
                  label="Other Documents (Optional)"
                  onChange={(e) => handleFileChange(e, "otherDocumentsFile")}
                  onClick={() => uploadPhotoHandler("otherDocumentsRef")}
                  onRemove={() =>
                    setStudentData((prev) => ({
                      ...prev,
                      otherDocumentsFile: { fileName: "", url: "" },
                    }))
                  }
                />
              </Stack>
              
              <Stack sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                mt: 2,
                gap: 2,
                width: "100%",
              }}>
                <ButtonMain
                  variant="white"
                  onClick={previousHandler}
                >
                  Back
                </ButtonMain>
                <ButtonMain
                  variant="green"
                  onClick={addAttachmentDetailHandler}
                >
                  Submit
                </ButtonMain>
              </Stack>
            </Stack>
          ) : null}
        </Grid>
      </Box>
    </Stack>
  );
}

export default OnBoardingForm